<template>
  <b-modal
    id="health-state-delete-modal"
    content-class="delete-modal-content"
    title="Supprimer un état de santé"
    @ok="handleOk"
    ok-title="Supprimer"
    ok-variant="danger"
    cancel-title="Annuler"
    :hide-footer="!canBeDeleted"
  >
    <div v-if="selectedHealthState !== null">
      <div v-if="canBeDeleted">
        Supprimer l'état de santé "{{selectedHealthState.name}}" ?
      </div>
      <div v-else>
        L'état de santé "{{selectedHealthState.name}}" ne peut pas être supprimé car il est associé à un ou plusieurs états quotidiens.
      </div>
    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'HealthStateDeleteModal',

  props: {
    selectedHealthState: Object
  },

  computed: {
    canBeDeleted() {
      if (this.selectedHealthState === null) {
        return false
      }
      return this.selectedHealthState.dailyStatusesCount === 0
    }
  },

  emits: ['didDeleteHealthState'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {

      let healthStateName = this.selectedHealthState.name

      api
        .delete(`/healthState/${this.selectedHealthState.id}`)
        .then(response => {
          this.$emit('didDeleteHealthState')
          this.hideModal()
          this.successToast(`État de santé \"${healthStateName}\" supprimé`)
        })
        .catch((error) => {
          if (error.response.status === 418) {
            this.$bvToast.toast(error.response.data.message, {
              autoHideDelay: 2000,
              toaster: 'b-toaster-bottom-right'
            })
          }
        });
    },

    hideModal() {
      this.$bvModal.hide('health-state-delete-modal')
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/views/healthState/HealthStateDeleteModal.vue